import { IdValue } from '../../../shared/models/id-value.model';

export const filingStatusTypes: IdValue[] = [
  new IdValue(0, 'NotAssigned', 'Please Select'),
  new IdValue(1, 'Jointly', 'Jointly'),
  new IdValue(3, 'NotJointly', 'Not Jointly'),
];

export const pmiTypes: IdValue[] = [
  new IdValue(1, 'None', 'Monthly Non-Refundable'),
  new IdValue(2, 'LevelAnnual', 'Level Annual'),
  new IdValue(3, 'StandardAnnual', 'Standard Annual'),
  new IdValue(4, 'SinglePremiumRefundable', 'Single Prem. Refundable'),
  new IdValue(5, 'SinglePremiumNonRefundable', 'Single Prem. Non Refundable'),
  new IdValue(6, 'LenderPaid', 'Lender Paid'),
  new IdValue(7, 'SplitPremiumNonRefundable', 'Split Prem. Non-Refundable'),
  new IdValue(8, 'QMSinglePremium', 'QM Single Premium'),
  new IdValue(9, 'QMSplitPremium', 'QM Split Premium'),
  new IdValue(10, 'QMStandardAnnual', 'QM Standard Annual'),
  new IdValue(11, 'MonthlyRefundable', 'Monthly Refundable'),
  new IdValue(12, 'SplitPremiumRefundable', 'Split Prem. Refundable'),
];

export const loanPurposeTypes: IdValue[] = [
  new IdValue(0, 'NotAssigned', ''),
  new IdValue(1, 'Purchase', 'Purchase'),
  new IdValue(2, 'Refinance', 'Refinance'),
  new IdValue(3, 'Construction', 'Construction'),
  new IdValue(4, 'ConstructionPerm', 'Construction Perm'),
  new IdValue(5, 'Second', 'Second'),
  new IdValue(6, 'Third', 'Third'),
  new IdValue(7, 'PurchaseMoneySecond', 'Second - Purchase Money'),
  new IdValue(8, 'Other', 'Other'),
  new IdValue(9, 'PurchaseMoneyThird', 'Third - Purchase Money'),
  new IdValue(10, 'RefiSecond', 'Second - Refinance'),
  new IdValue(11, 'RefiThird', 'Third - Refinance'),
];

export const refiTypes: IdValue[] = [
  new IdValue(0, 'NotAssigned', ''),
  new IdValue(1, 'CashOutDebtConsolidation', 'Cash-Out Debt Consolidation'),
  new IdValue(2, 'CashOutHomeImprovement', 'Cash-Out Home Improvement'),
  new IdValue(3, 'CashOutLimited', 'Limited Cash Out'),
  new IdValue(4, 'CashOutOther', 'Cash-Out Other'),
  new IdValue(5, 'NoCashOutFHAStreamlinedRefinance', 'No Cash-Out FHA Streamlined Refinance'),
  new IdValue(6, 'NoCashOutFREOwnedRefinance', 'No Cash-Out FRE Owned Refinance'),
  new IdValue(7, 'NoCashOutOther', 'No Cash-Out Other'),
  new IdValue(8, 'NoCashOutStreamlinedRefinance', 'No Cash-Out Streamlined Refinance'),
  new IdValue(9, 'ChangeInRateTerm', 'Change In Rate Term'),
  new IdValue(10, 'PurchaseMoneyThird', 'Purchase Money Third'),
  new IdValue(11, 'RefiSecond', 'RefiSecond'),
];

export const refiTypesFHA: IdValue[] = [
  new IdValue(0, 'NotAssigned', ''),
  new IdValue(1, 'StreamlinedWithAppraisal', 'Streamlined with Appraisal'),
  new IdValue(2, 'StreamlinedWithoutAppraisal', 'Streamlined without Appraisal'),
  new IdValue(3, 'NoCashOut', 'No Cash-Out'),
  new IdValue(4, 'CashOut', 'Cash-Out'),
];

export const refiTypesVA: IdValue[] = [new IdValue(0, 'NotAssigned', ''), new IdValue(1, 'IRRR', 'IRRR'), new IdValue(2, 'Other', 'Other')];

export const qmTypes: IdValue[] = [
  new IdValue(0, 'NotAssigned', ''),
  new IdValue(1, 'NotEvaluated', ''),
  new IdValue(2, 'Unknown', ''),
  new IdValue(3, 'Passed', 'Pass'),
  new IdValue(4, 'Failed', 'Fail'),
  new IdValue(5, 'PassedSafeHarbor', 'Pass'),
  new IdValue(6, 'PassedRebuttablePresumption', 'Pass'),
];

export const hpmlTypes: IdValue[] = [
  new IdValue(0, 'NotAssigned', ''),
  new IdValue(1, 'HPML', 'Pass'),
  new IdValue(2, 'NotHPML', 'Fail'),
  new IdValue(3, 'NotEvaluated', ''),
  new IdValue(4, 'Unknown', 'Unknown'),
];

export const occupancyTypes: IdValue[] = [
  new IdValue(0, 'NotAssigned', ''),
  new IdValue(1, 'PrimaryResidence', 'Primary Residence'),
  new IdValue(2, 'SecondaryResidence', 'Secondary Residence'),
  new IdValue(3, 'InvestmentProperty', 'Investment Property'),
];

export const taxFormTypes: IdValue[] = [
  new IdValue(0, 'Unknown', 'Please Select'),
  new IdValue(1, 'TaxForm_1040', '1040'),
  new IdValue(2, 'TaxForm_W2', 'W-2'),
];
